<template>
  <div class="container-fluid px-0">
    <div class="row content mx-0">
      <div class="col-1 px-0"></div>
      <div class="col-10 px-0">
        <div class="row mx-0">
          <div class="col-12 px-0 text-end my-3 machStatus-update-time">
            <span class="my-0" id="machStatus-update-time">更新時間:</span>
            <span class="my-0" for="machStatus-update-time">
              {{ nowTime }}
            </span>
          </div>
          <div class="col-12 px-0 text-start">
            <button class="machStatus-button mx-0" @click="detail = false">
              返回
            </button>
          </div>
          <div class="col-12 px-0">
            <div class="row mx-0">
              <div class="col-12 mt-3 px-0 mb-2">
                <div class="row mx-0">
                  <div
                    class="col-12 col-md-12 col-lg-4 col-xl-3 col-xxl-3 px-0"
                  >
                    <img
                      :src="machineImage"
                      class="mx-auto machStatus-main-image"
                      alt="Center image"
                    />
                  </div>
                  <div
                    class="col-12 col-md-12 col-lg-8 col-xl-9 col-xxl-9 px-0"
                  >
                    <div class="row mx-0 text-start machStatus-introduce">
                      <div class="col-12 col-xxl-7 px-0">
                        <div class="row mx-0">
                          <div
                            class="col-6 col-sm-3 col-md-3 col-lg-3 col-xl-3 col-xxl-3 px-0 machStatus-introduce-list"
                          >
                            製程:{{ siteName }}
                          </div>
                          <div
                            class="col-6 col-sm-3 col-md-3 col-lg-3 col-xl-3 col-xxl-3 px-0 machStatus-introduce-list"
                          >
                            產線:{{ operName }}
                          </div>
                          <div
                            class="col-6 col-sm-3 col-md-3 col-lg-3 col-xl-3 col-xxl-3 px-0 machStatus-introduce-list"
                          >
                            機號:{{ deviceName }}
                          </div>
                          <div
                            class="col-6 col-sm-3 col-md-3 col-lg-3 col-xl-3 col-xxl-3 px-0 machStatus-introduce-list"
                          >
                            型號:{{ deviceModel }}
                          </div>
                        </div>
                      </div>
                      <div
                        class="col-12 col-xxl-5 px-0 machStatus-status-bar machStatus-introduce-list"
                      >
                        狀態:
                        <div class="machStatus-status-color-bar">
                          <div class="d-flex justify-content-start">
                            <div
                              :style="{
                                'background-color':
                                  machine_status === 'R'
                                    ? 'var(--main-status-success-color)'
                                    : machine_status === 'I'
                                    ? 'var(--main-status-short-color)'
                                    : 'var(--main-status-stop-color)',
                              }"
                              style="color: var(--main-font-color)"
                            >
                              {{
                                machine_status === "R"
                                  ? "運轉"
                                  : machine_status === "I"
                                  ? "短寸"
                                  : "運轉"
                              }}
                            </div>
                            <div
                              :style="{
                                'background-color':
                                  machine_status === 'Q'
                                    ? 'var(--main-status-warning-color)'
                                    : machine_status === 'M'
                                    ? 'var(--main-status-maintain-color)'
                                    : machine_status === 'D'
                                    ? 'var(--main-status-shunting-color)'
                                    : 'var(--main-status-stop-color)',
                              }"
                              style="color: var(--main-font-color)"
                            >
                              {{
                                machine_status === "Q"
                                  ? "待機"
                                  : machine_status === "M"
                                  ? "維修"
                                  : machine_status === "D"
                                  ? "調車"
                                  : "待機"
                              }}
                            </div>
                            <div
                              :style="{
                                'background-color':
                                  machine_status === 'H'
                                    ? 'var(--main-status-danger-color)'
                                    : 'var(--main-status-stop-color)',
                              }"
                              style="color: var(--main-font-color)"
                            >
                              異常
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="row mx-0">
                      <div class="col-12 px-0 mb-2">
                        <div class="input-group machStatus-input-group">
                          <span
                            class="input-group-text machStatus-input-group-text"
                            >機台狀態</span
                          >
                          <input
                            type="text"
                            aria-label="First name"
                            class="form-control"
                            disabled
                            :value="'運轉時間：' + deviceRunTime"
                            style="min-width: 180px"
                          />
                          <input
                            type="text"
                            aria-label="Last name"
                            class="form-control"
                            disabled
                            :value="'待機時間：' + deviceQueueTime"
                            style="min-width: 180px"
                          />
                          <input
                            type="text"
                            aria-label="Last name"
                            class="form-control"
                            disabled
                            :value="'開機稼動率：' + deviceActivation + '%'"
                            style="min-width: 165px"
                          />
                          <input
                            type="text"
                            aria-label="Last name"
                            class="form-control"
                            disabled
                            :value="'日累計產量：' + deviceDayCount + '(PCS)'"
                            style="min-width: 215px"
                          />
                          <input
                            type="text"
                            aria-label="Last name"
                            class="form-control"
                            disabled
                            :value="'標準RPM：' + deviceCapacityMin"
                            style="min-width: 135px"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="px-0">
                    <stackBar
                      :stacksBarClass="stacksBarClass"
                      :stacksBarMaxValue="stacksBarMaxValue"
                      :stacksData="stackBarInformation"
                      :stacksSize="'normal'"
                    />
                  </div>
                </div>
              </div>
              <div class="col-12 my-3 px-0">
                <nav class="px-0">
                  <div
                    class="nav nav-tabs mes-tabs"
                    id="nav-tab"
                    role="tablist"
                  >
                    <button
                      class="nav-link mes-tab"
                      :class="{ active: detailTabIndex == 0 }"
                      id="nav-instant-tab"
                      data-bs-toggle="tab"
                      data-bs-target="#nav-instant"
                      type="button"
                      role="tab"
                      aria-controls="nav-instant"
                      aria-selected="true"
                      @click="detailTabIndex = 0"
                    >
                      即時工單狀態
                    </button>
                    <button
                      class="nav-link mes-tab"
                      :class="{ active: detailTabIndex == 1 }"
                      id="nav-remain-tab"
                      data-bs-toggle="tab"
                      data-bs-target="#nav-remain"
                      type="button"
                      role="tab"
                      aria-controls="nav-remain"
                      aria-selected="false"
                      @click="detailTabIndex = 1"
                    >
                      工單餘量
                    </button>
                    <button
                      class="nav-link mes-tab"
                      :class="{ active: detailTabIndex == 2 }"
                      id="nav-camera-tab"
                      data-bs-toggle="tab"
                      data-bs-target="#nav-camera"
                      type="button"
                      role="tab"
                      aria-controls="nav-camera"
                      aria-selected="false"
                      @click="detailTabIndex = 2"
                    >
                      機台影像
                    </button>
                    <button
                      class="nav-link mes-tab"
                      :class="{ active: detailTabIndex == 3 }"
                      id="nav-operate-tab"
                      data-bs-toggle="tab"
                      data-bs-target="#nav-operate"
                      type="button"
                      role="tab"
                      aria-controls="nav-operate"
                      aria-selected="false"
                      @click="detailTabIndex = 3"
                    >
                      運轉日誌
                    </button>
                    <button
                      class="nav-link mes-tab"
                      :class="{ active: detailTabIndex == 4 }"
                      id="nav-complete-tab"
                      data-bs-toggle="tab"
                      data-bs-target="#nav-complete"
                      type="button"
                      role="tab"
                      aria-controls="nav-complete"
                      aria-selected="false"
                      @click="detailTabIndex = 4"
                    >
                      當日完成工單
                    </button>
                    <button
                      class="nav-link mes-tab"
                      :class="{ active: detailTabIndex == 5 }"
                      id="nav-alarm-tab"
                      data-bs-toggle="tab"
                      data-bs-target="#nav-alarm"
                      type="button"
                      role="tab"
                      aria-controls="nav-alarm"
                      aria-selected="false"
                      @click="detailTabIndex = 5"
                    >
                      警報履歷
                    </button>
                    <button
                      class="nav-link mes-tab"
                      :class="{ active: detailTabIndex == 6 }"
                      id="nav-light-tab"
                      data-bs-toggle="tab"
                      data-bs-target="#nav-light"
                      type="button"
                      role="tab"
                      aria-controls="nav-light"
                      aria-selected="false"
                      @click="detailTabIndex = 6"
                    >
                      機台指示燈號
                    </button>
                  </div>
                </nav>
                <div
                  class="tab-content machStatus-tab-content pb-2"
                  id="nav-tabContent"
                >
                  <!-- 即時工單狀態 -->
                  <div
                    class="tab-pane fade"
                    :class="{
                      'show active': detailTabIndex == 0,
                    }"
                    id="nav-instant"
                    role="tabpanel"
                    aria-labelledby="nav-instant-tab"
                  >
                    <div class="row mx-0">
                      <div class="col-12 machStatus-paragraph">
                        <div class="machStatus-paragraph-title">
                          <span>工單資訊</span>
                        </div>
                        <commonTable
                          :fields="workCodeFields"
                          :items="workCodeItems"
                        />
                      </div>
                      <div class="col-12 machStatus-paragraph">
                        <div class="machStatus-paragraph-title">
                          <span>生產資訊</span>
                        </div>
                        <commonTable
                          :fields="produceFields"
                          :items="produceItems"
                        >
                          <template #cell(qty)="data">
                            {{ data.value.name }}:
                            {{
                              isNaN(Number(data.value.count))
                                ? data.value.count
                                : Number(data.value.count).toLocaleString(
                                    "en-US"
                                  )
                            }}
                          </template>
                          <template #cell(unitWeight)="data">{{
                            isNaN(Number(data.value))
                              ? data.value
                              : Number(data.value).toLocaleString("en-US")
                          }}</template>
                          <template #cell(standardTotalWeight)="data">{{
                            isNaN(Number(data.value))
                              ? data.value
                              : Number(data.value).toLocaleString("en-US")
                          }}</template>
                          <template #cell(materialTotalWeight)="data">{{
                            isNaN(Number(data.value))
                              ? data.value
                              : Number(data.value).toLocaleString("en-US")
                          }}</template>
                        </commonTable>
                        <!-- 進度條 -->
                        <div
                          class="progress position-relative machStatus-percent-bar"
                          style="margin-top: 1rem"
                        >
                          <div
                            class="progress-bar"
                            :class="{
                              'machStatus-progress-bar-R':
                                machine_status == 'R',
                              'machStatus-progress-bar-Q':
                                machine_status == 'Q',
                              'machStatus-progress-bar-H':
                                machine_status == 'H',
                              'machStatus-progress-bar-D':
                                machine_status == 'D',
                              'machStatus-progress-bar-I':
                                machine_status == 'I',
                              'machStatus-progress-bar-M':
                                machine_status == 'M',
                            }"
                            :style="{
                              width: percent_bar.work_percent + '%',
                            }"
                          ></div>
                          <span
                            v-if="percent_bar.work_code != ''"
                            class="mb-0 machStatus-percent-bar-text"
                          >
                            {{
                              (isNaN(Number(percent_bar.device_count))
                                ? percent_bar.device_count
                                : Number(
                                    percent_bar.device_count
                                  ).toLocaleString("en-US")) +
                              "/" +
                              (isNaN(Number(percent_bar.work_qty))
                                ? percent_bar.work_qty
                                : Number(percent_bar.work_qty).toLocaleString(
                                    "en-US"
                                  )) +
                              " " +
                              percent_bar.work_percent +
                              "%"
                            }}
                          </span>
                        </div>
                      </div>
                      <div class="col-12 machStatus-paragraph">
                        <div class="machStatus-paragraph-title">
                          <span>線材使用資訊</span>
                        </div>
                        <commonTable
                          :fields="wireFields"
                          :items="wireItems"
                          :extraItems="wireExtraItems"
                        >
                          <template #cell(item)="data">{{
                            data.index + 1
                          }}</template>
                          <template #cell(start_weight)="data">{{
                            isNaN(Number(data.value))
                              ? data.value
                              : Number(data.value).toLocaleString("en-US")
                          }}</template>
                          <template #cell(remain_weight)="data">{{
                            isNaN(Number(data.value))
                              ? data.value
                              : Number(data.value).toLocaleString("en-US")
                          }}</template>
                          <template #cell(consumption)="data">{{
                            isNaN(Number(data.value))
                              ? data.value
                              : Number(data.value).toLocaleString("en-US")
                          }}</template>
                        </commonTable>
                      </div>
                      <div class="col-12 machStatus-paragraph">
                        <div class="machStatus-paragraph-title">
                          <span>使用模具資訊</span>
                        </div>
                        <commonTable
                          :fields="mouldFields"
                          :items="mouldItems"
                          stickyHeader="186px"
                        >
                          <template #cell(usedLife)="data">{{
                            isNaN(Number(data.value))
                              ? data.value
                              : Number(data.value).toLocaleString("en-US")
                          }}</template>
                          <template #cell(standardLife)="data">{{
                            isNaN(Number(data.value))
                              ? data.value
                              : Number(data.value).toLocaleString("en-US")
                          }}</template>
                        </commonTable>
                      </div>
                      <div class="col-12 machStatus-paragraph">
                        <div class="machStatus-paragraph-title">
                          <span>每桶產出</span>
                        </div>
                        <commonTable
                          :fields="bucketFields"
                          :items="bucketItems"
                          stickyHeader="186px"
                        >
                          <template #cell(screwWeight)="data">{{
                            isNaN(Number(data.value))
                              ? data.value
                              : Number(data.value).toLocaleString("en-US")
                          }}</template>
                        </commonTable>
                      </div>
                      <div class="col-12 machStatus-paragraph">
                        <div class="machStatus-paragraph-title">
                          <span>總生產時間</span>
                        </div>
                        <commonTable
                          :fields="produceTimeFields"
                          :items="produceTimeItems"
                        />
                      </div>
                      <div class="col-12 machStatus-paragraph">
                        <div class="machStatus-paragraph-title">
                          <span>檢驗數值</span>
                        </div>
                        <inspectionList
                          :inspectionData="insp_value"
                        ></inspectionList>
                        <div></div>
                      </div>
                    </div>
                  </div>
                  <!-- 工單餘量 -->
                  <div
                    class="tab-pane fade"
                    :class="{
                      'show active': detailTabIndex == 1,
                    }"
                    id="nav-remain"
                    role="tabpanel"
                    aria-labelledby="nav-remain-tab"
                  >
                    <div class="row mx-0">
                      <div class="col-12 machStatus-paragraph">
                        <div class="machStatus-paragraph-title">
                          <span>工單餘量</span>
                        </div>
                        <commonTable
                          :fields="workCodeRemainFields"
                          :items="workCodeRemainItems"
                          stickyHeader="465px"
                        >
                          <template #cell(work_qty)="data">{{
                            isNaN(Number(data.value))
                              ? data.value
                              : Number(data.value).toLocaleString("en-US")
                          }}</template>
                          <template #cell(work_stand_weight)="data">{{
                            isNaN(Number(data.value))
                              ? data.value
                              : Number(data.value).toLocaleString("en-US")
                          }}</template>
                        </commonTable>
                      </div>
                    </div>
                  </div>
                  <!-- 機台影像 -->
                  <div
                    class="tab-pane fade"
                    :class="{
                      'show active': detailTabIndex == 2,
                    }"
                    id="nav-camera"
                    role="tabpanel"
                    aria-labelledby="nav-camera-tab"
                  >
                    <div class="row mx-0">
                      <div class="col-12 machStatus-paragraph text-start mt-3">
                        <machineCamera :machineCameraData="machineCameraData" />
                      </div>
                    </div>
                  </div>
                  <!-- 運轉日誌 -->
                  <div
                    class="tab-pane fade"
                    :class="{
                      'show active': detailTabIndex == 3,
                    }"
                    id="nav-operate"
                    role="tabpanel"
                    aria-labelledby="nav-operate-tab"
                  >
                    <div class="row mx-0">
                      <div class="col-12 machStatus-paragraph">
                        <div class="text-end" style="margin-bottom: 0.6rem">
                          <exportCsv
                            :exportData="operateLogItems"
                            :exportDataTitle="
                              operateLogFields.map((item) => item.label)
                            "
                            :exportFileName="
                              '運轉日誌_' +
                              deviceName +
                              '_' +
                              new Date().getFullYear() +
                              ('0' + (new Date().getMonth() + 1)).slice(-2) +
                              ('0' + new Date().getDate()).slice(-2)
                            "
                          />
                        </div>
                        <commonTable
                          :fields="operateLogFields"
                          :items="operateLogItems"
                          :tableStyle="{'white-space': 'pre-line'}"
                          stickyHeader="230px"
                        >
                          <template #cell(status)="data">
                            <template
                              v-if="
                                data.item.alarmCode != '' &&
                                data.item.alarmCode.indexOf('E_MC_3_') != -1 &&
                                data.item.status == '警報'
                              "
                            >
                              <b style="color: red">{{ data.value }}</b>
                            </template>
                            <template v-else>
                              {{ data.value }}
                            </template>
                          </template>
                          <template #cell(alarmCode)="data">
                            <template
                              v-if="
                                data.item.alarmCode != '' &&
                                data.item.alarmCode.indexOf('E_MC_3_') != -1 &&
                                data.item.status == '警報'
                              "
                            >
                              <b style="color: red">{{ data.value }}</b>
                            </template>
                            <template v-else>
                              {{ data.value }}
                            </template>
                          </template>
                          <template #cell(alarmDetail)="data">
                            <template
                              v-if="
                                data.item.alarmCode != '' &&
                                data.item.alarmCode.indexOf('E_MC_3_') != -1 &&
                                data.item.status == '警報'
                              "
                            >
                              <b style="color: red">{{ data.value }}</b>
                            </template>
                            <template v-else>
                              {{ data.value }}
                            </template>
                          </template>
                          <template #cell(startTime)="data">
                            <template
                              v-if="
                                data.item.alarmCode != '' &&
                                data.item.alarmCode.indexOf('E_MC_3_') != -1 &&
                                data.item.status == '警報'
                              "
                            >
                              <b style="color: red">{{ data.value }}</b>
                            </template>
                            <template v-else>
                              {{ data.value }}
                            </template>
                          </template>
                          <template #cell(endTime)="data">
                            <template
                              v-if="
                                data.item.alarmCode != '' &&
                                data.item.alarmCode.indexOf('E_MC_3_') != -1 &&
                                data.item.status == '警報'
                              "
                            >
                              <b style="color: red">{{ data.value }}</b>
                            </template>
                            <template v-else>
                              {{ data.value }}
                            </template>
                          </template>
                          <template #cell(durationTime)="data">
                            <template
                              v-if="
                                data.item.alarmCode != '' &&
                                data.item.alarmCode.indexOf('E_MC_3_') != -1 &&
                                data.item.status == '警報'
                              "
                            >
                              <b style="color: red">{{ data.value }}</b>
                            </template>
                            <template v-else>
                              {{ data.value }}
                            </template>
                          </template>
                        </commonTable>
                      </div>
                    </div>
                  </div>
                  <!-- 當日完成工單 -->
                  <div
                    class="tab-pane fade"
                    :class="{
                      'show active': detailTabIndex == 4,
                    }"
                    id="nav-complete"
                    role="tabpanel"
                    aria-labelledby="nav-complete-tab"
                  >
                    <div class="row mx-0">
                      <div class="col-12 machStatus-paragraph">
                        <template v-if="!completeWorkdetail">
                          <commonTable
                            :fields="completeWorkFields"
                            :items="completeWorkItems"
                            :rowClick="completeWorkRowClick"
                            stickyHeader="465px"
                          >
                            <template #cell(qty)="data">{{
                              isNaN(Number(data.value))
                                ? data.value
                                : Number(data.value).toLocaleString("en-US")
                            }}</template>
                            <template #cell(completeQty)="data">{{
                              isNaN(Number(data.value))
                                ? data.value
                                : Number(data.value).toLocaleString("en-US")
                            }}</template>
                            <template #cell(weight)="data">{{
                              isNaN(Number(data.value))
                                ? data.value
                                : Number(data.value).toLocaleString("en-US")
                            }}</template>
                            <template #cell(completeWeight)="data">{{
                              isNaN(Number(data.value))
                                ? data.value
                                : Number(data.value).toLocaleString("en-US")
                            }}</template>
                          </commonTable>
                        </template>
                        <template v-else>
                          <div class="col-12 mb-2 px-0 text-end">
                            <button
                              class="machStatus-button"
                              @click="completeWorkdetail = false"
                            >
                              返回
                            </button>
                          </div>
                          <workOrderHistoryList></workOrderHistoryList>
                        </template>
                      </div>
                    </div>
                  </div>
                  <!-- 警報履歷 -->
                  <div
                    class="tab-pane fade"
                    :class="{
                      'show active': detailTabIndex == 5,
                    }"
                    id="nav-alarm"
                    role="tabpanel"
                    aria-labelledby="nav-alarm-tab"
                  >
                    <div class="row mx-0">
                      <div class="col-12 machStatus-paragraph">
                        <div class="text-end" style="margin-bottom: 0.6rem">
                          <exportCsv
                            :exportData="alarmHistoryItems"
                            :exportDataTitle="
                              alarmHistoryFields.map((item) => item.label)
                            "
                            :exportFileName="
                              '警報履歷_' +
                              deviceName +
                              '_' +
                              new Date().getFullYear() +
                              ('0' + (new Date().getMonth() + 1)).slice(-2) +
                              ('0' + new Date().getDate()).slice(-2)
                            "
                          />
                        </div>
                        <commonTable
                          :fields="alarmHistoryFields"
                          :items="alarmHistoryItems"
                          :tableStyle="{'white-space': 'pre-line'}"
                          stickyHeader="230px"
                        />
                      </div>
                    </div>
                  </div>
                  <!-- 機台指示燈號 -->
                  <div
                    class="tab-pane fade"
                    :class="{
                      'show active': detailTabIndex == 6,
                    }"
                    id="nav-light"
                    role="tabpanel"
                    aria-labelledby="nav-light-tab"
                  >
                    <div class="text-left col-12">
                      <div class="row justify-content-start mx-0 p-3">
                        <div
                          v-for="(item, key) in machineLightData"
                          class="mt-2 ml-0 justify-content-center col-sm-6 col-md-4 col-lg-3 col-xl-2 col-6"
                        >
                          <light :name="item.name" :color="item.color" />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-1 px-0"></div>
    </div>
  </div>
</template>

<script>
import { useStore } from "vuex";
import { computed, inject, provide, ref, watch } from "@vue/runtime-core";
import stackBar from "@/components/stackBar.vue";
import commonTable from "@/components/commonTable.vue";
import machineCamera from "@/components/machineCamera.vue";
import exportCsv from "@/components/exportCsv.vue";
import workOrderHistoryList from "@/components/workOrderHistoryList.vue";
import inspectionList from "@/components/inspectionList.vue";
import light from "@/components/light.vue";
export default {
  components: {
    stackBar,
    commonTable,
    machineCamera,
    exportCsv,
    workOrderHistoryList,
    inspectionList,
    light,
  },
  setup() {
    const siteName = inject("siteName");
    const oper = inject("oper");
    const operName = inject("operName");
    const deviceName = inject("deviceName");
    const detail = inject("detail");
    const machStatusData = inject("machStatusData");
    const nowTime = inject("nowTime");
    const detailTabIndex = inject("detailTabIndex");
    const commonMethods = inject("commonMethods");

    const store = useStore();

    //getters
    const loginData = computed(() => store.getters["getLogin/get_loginData"]);
    const sideNavPath = computed(
      () => store.getters["sideBarTree/get_sideNavPath"]
    );
    const axiosResult = computed(
      () => store.getters["commonAxios/get_axiosResult"]
    );
    const stacksBarClass = computed(
      () => store.getters["stackBar/get_stacksBarClass"]
    );
    const stacksBarMaxValue = computed(
      () => store.getters["stackBar/get_stacksBarMaxValue"]
    );
    const stacksBarDefault = computed(
      () => store.getters["stackBar/get_stacksBarDefault"]
    );

    //dispatch
    const methods = {
      axiosAction: async (payload) => {
        await store.dispatch("commonAxios/axiosAction", payload);
      },
      triggerLoadingBar: () => {
        store.dispatch("commonLoadingBar/triggerLoadingBar");
      },
      setTimeoutAlert: (alertText) => {
        store.dispatch("commonAlert/setTimeoutAlert", [alertText]);
      },
    };

    const machineImage = require("@/assets/CBF.jpg");
    const machine_status = ref("R");
    const deviceRunTime = ref("-");
    const deviceQueueTime = ref("-");
    const deviceActivation = ref("-");
    const deviceModel = ref("-");
    const deviceDayCount = ref("-");
    const deviceCapacityMin = ref("-");
    const stackBarInformation = ref(stacksBarDefault.value);
    console.log(siteName.value, operName.value, deviceName.value, detail.value);

    //工單資訊
    const workCodeFields = [
      {
        key: "workOrgCode",
        label: "工單編號",
        thStyle: {
          "min-width": "85px",
          "font-size": "16px",
        },
        tdStyle: {
          "font-size": "16px",
        },
      },
      {
        key: "productCode",
        label: "料號",
        thStyle: {
          "min-width": "220px",
          "font-size": "16px",
        },
        tdStyle: {
          "font-size": "16px",
        },
      },
      {
        key: "workControlCard",
        label: "管制卡號",
        thStyle: {
          "min-width": "160px",
          "font-size": "16px",
        },
        tdStyle: {
          "font-size": "16px",
        },
      },
      {
        key: "productChineseName",
        label: "料名",
        thStyle: {
          "min-width": "380px",
          "font-size": "16px",
        },
        tdStyle: {
          "font-size": "16px",
        },
      },
    ];
    const workCodeItems = ref([]);

    //生產資訊
    const produceFields = [
      {
        key: "itemTitle",
        label: ["項目", "狀態"],
        segmentation: {
          sup: {},
          sub: {},
        },
        thStyle: {
          "font-size": "16px",
        },
        tdStyle: {
          "font-size": "16px",
        },
      },
      {
        key: "qty",
        label: "數量(PCS)",
        thStyle: {
          "min-width": "180px",
          "font-size": "16px",
        },
        tdStyle: {
          "font-size": "16px",
        },
      },
      {
        key: "unitWeight",
        label: "單支重(G)",
        thStyle: {
          "min-width": "75px",
          "font-size": "16px",
        },
        tdStyle: {
          "font-size": "16px",
        },
      },
      {
        key: "standardTotalWeight",
        label: "生產總重(KG)",
        thStyle: {
          "min-width": "100px",
          "font-size": "16px",
        },
        tdStyle: {
          "font-size": "16px",
        },
      },
      {
        key: "materialTotalWeight",
        label: "原料使用總重(KG)",
        thStyle: {
          "min-width": "135px",
          "font-size": "16px",
        },
        tdStyle: {
          "font-size": "16px",
        },
      },
    ];
    const produceItems = ref([
      // {
      //   itemTitle: "實際",
      //   qty: {
      //     name: "計數器支數",
      //     count: 531,
      //   },
      //   unitWeight: "394.2",
      //   standardTotalWeight: 0,
      //   unit_material_weight: "-",
      //   materialTotalWeight: "-",
      // },
      // {
      //   itemTitle: "標準",
      //   qty: {
      //     name: "派工支數",
      //     count: "990",
      //   },
      //   unitWeight: "410.89",
      //   standardTotalWeight: "406.78",
      //   unit_material_weight: "411.30746",
      //   materialTotalWeight: "407.19",
      // },
    ]);
    const percent_bar = ref({
      work_code: "-",
      device_count: 0,
      work_qty: 0,
      work_percent: 0,
    });

    //線材使用資訊
    const wireFields = [
      {
        key: "item",
        label: "項次",
        thStyle: {
          "min-width": "60px",
          "font-size": "16px",
        },
        tdStyle: {
          "font-size": "16px",
        },
      },
      {
        key: "code",
        label: "線材品號",
        thStyle: {
          "min-width": "100px",
          "font-size": "16px",
        },
        tdStyle: {
          "font-size": "16px",
        },
      },
      {
        key: "chinese_name",
        label: "線材品名",
        thStyle: {
          "min-width": "200px",
          "font-size": "16px",
        },
        tdStyle: {
          "font-size": "16px",
        },
      },
      {
        key: "scroll_no",
        label: "線材捲號",
        thStyle: {
          "min-width": "165px",
          "font-size": "16px",
        },
        tdStyle: {
          "font-size": "16px",
        },
      },
      {
        key: "furnaceCode",
        label: "爐號",
        thStyle: {
          "min-width": "65px",
          "font-size": "16px",
        },
        tdStyle: {
          "font-size": "16px",
        },
      },
      {
        key: "start_weight",
        label: "起始重量(KG)",
        thStyle: {
          "min-width": "105px",
          "font-size": "16px",
        },
        tdStyle: {
          "font-size": "16px",
        },
      },
      {
        key: "remain_weight",
        label: "剩餘重量(KG)",
        thStyle: {
          "min-width": "105px",
          "font-size": "16px",
        },
        tdStyle: {
          "font-size": "16px",
        },
      },
      {
        key: "consumption",
        label: "耗用量(KG)",
        thStyle: {
          "min-width": "85px",
          "font-size": "16px",
        },
        tdStyle: {
          "font-size": "16px",
        },
      },
    ];
    const wireItems = ref([
      // {
      //   furnaceCode: "65258",
      //   status: "S",
      //   code: "B33M144027",
      //   consumption: 1307,
      //   chinese_name: "原料 線材 SAE碳鋼 10B33 外購 一球二抽 2火 14.40mm",
      //   scroll_no: "WE_I202303176-002",
      //   remain_weight: 0,
      //   start_weight: 1307,
      //   attrition: "-",
      // },
    ]);
    const wireExtraItems = ref(["總計", 0]);

    //使用模具資訊
    const mouldFields = [
      {
        key: "code",
        label: "零件編號",

        thStyle: {
          "min-width": "250px",
          "font-size": "16px",
        },
        tdStyle: {
          "font-size": "16px",
        },
      },
      {
        key: "seriesNo",
        label: "零件序號",
        thStyle: {
          "min-width": "100px",
          "font-size": "16px",
        },
        tdStyle: {
          "font-size": "16px",
        },
      },
      {
        key: "name",
        label: "零件名稱",
        thStyle: {
          "min-width": "330px",
          "font-size": "16px",
        },
        tdStyle: {
          "font-size": "16px",
        },
      },
      {
        key: "usedLife",
        label: "累積使用壽命",
        thStyle: {
          "min-width": "110px",
          "font-size": "16px",
        },
        tdStyle: {
          "font-size": "16px",
        },
      },
      {
        key: "standardLife",
        label: "標準壽命",
        thStyle: {
          "min-width": "75px",
          "font-size": "16px",
        },
        tdStyle: {
          "font-size": "16px",
        },
      },
    ];
    const mouldItems = ref([
      // {
      //   code: "MCLC1IBBM06325201500A2E**",
      //   seriesNo: "s11001_001",
      //   name: "M6-3#面模-ISO-7380-2-25.2X15(OF 010.9)-V",
      //   usedLife: 4220122,
      //   standardLife: 131000,
      // },
    ]);

    //每桶產出
    const bucketFields = [
      {
        key: "code",
        label: "流程卡號",

        thStyle: {
          "min-width": "100px",
          "font-size": "16px",
        },
        tdStyle: {
          "font-size": "16px",
        },
      },
      {
        key: "furnaceCode",
        label: "爐號",
        thStyle: {
          "min-width": "75px",
          "font-size": "16px",
        },
        tdStyle: {
          "font-size": "16px",
        },
      },
      {
        key: "screwWeight",
        label: "重量(KG)",
        thStyle: {
          "min-width": "80px",
          "font-size": "16px",
        },
        tdStyle: {
          "font-size": "16px",
        },
      },
    ];
    const bucketItems = ref([
      // {
      //   code: "33886X-01",
      //   furnaceCode: "66691",
      //   screwWeight: 558.5,
      // },
    ]);

    //總生產時間
    const produceTimeFields = [
      {
        key: "code",
        label: "製程",

        thStyle: {
          "min-width": "70px",
          "font-size": "16px",
        },
        tdStyle: {
          "font-size": "16px",
        },
      },
      {
        key: "device_name",
        label: "機台編號",
        thStyle: {
          "min-width": "80px",
          "font-size": "16px",
        },
        tdStyle: {
          "font-size": "16px",
        },
      },
      {
        key: "startTime",
        label: "開始時間",
        thStyle: {
          "min-width": "170px",
          "font-size": "16px",
        },
        tdStyle: {
          "font-size": "16px",
        },
      },
      {
        key: "endTime",
        label: "結束時間",
        thStyle: {
          "min-width": "170px",
          "font-size": "16px",
        },
        tdStyle: {
          "font-size": "16px",
        },
      },
      {
        key: "totalTime",
        label: "生產時間",
        thStyle: {
          "min-width": "160px",
          "font-size": "16px",
        },
        tdStyle: {
          "font-size": "16px",
        },
      },
    ];
    const produceTimeItems = ref([
      // {
      //   totalTime: "2小時2分1秒",
      //   deviceName: "B06",
      //   endTime: "-",
      //   startTime: "2023-03-31 12:57:46",
      //   code: "打頭",
      // },
    ]);

    const insp_value = ref({
      self: [],
      last: [],
      first: [],
    });

    //工單餘量資訊
    const workCodeRemainFields = [
      {
        key: "work_org_code",
        label: "工單編號",
        thStyle: {
          "min-width": "85px",
        },
        tdStyle: {
          "font-size": "16px",
        },
      },
      {
        key: "product_code",
        label: "料號",
        thStyle: {
          "min-width": "195px",
        },
        tdStyle: {
          "font-size": "16px",
        },
      },
      {
        key: "work_control_card",
        label: "管制卡號",
        thStyle: {
          "min-width": "220px",
        },
        tdStyle: {
          "font-size": "16px",
        },
      },
      {
        key: "product_chinese_name",
        label: "料名",
        thStyle: {
          "min-width": "560px",
        },
        tdStyle: {
          "font-size": "16px",
        },
      },
      {
        key: "mould_code",
        label: "模具編號",
        thStyle: {
          "min-width": "160px",
        },
        tdStyle: {
          "font-size": "16px",
        },
      },
      {
        key: "work_qty",
        label: "派工支數",
        thStyle: {
          "min-width": "100px",
        },
        tdStyle: {
          "font-size": "16px",
        },
      },
      {
        key: "work_stand_weight",
        label: "標準重量",
        thStyle: {
          "min-width": "100px",
        },
        tdStyle: {
          "font-size": "16px",
        },
      },
    ];
    const workCodeRemainItems = ref([]);

    //機台影像
    const machineCameraData = ref([
      // {
      //   url: "http://172.16.3.28:88/GetData.cgi?CH=1&WebUser=admin&WebPass=",
      //   cameraName: "IPCAM1",
      // },
      // {
      //   url: "http://172.16.3.28:89/GetData.cgi?CH=1&WebUser=admin&WebPass=",
      //   cameraName: "IPCAM2",
      // },
    ]);

    //運轉日誌資訊
    const operateLogFields = [
      {
        key: "status",
        label: "狀態",
        thStyle: {
          "min-width": "85px",
        },
        tdStyle: {
          "font-size": "16px",
        },
      },
      {
        key: "alarmCode",
        label: "代碼",
        thStyle: {
          "min-width": "130px",
        },
        tdStyle: {
          "font-size": "16px",
        },
      },
      {
        key: "alarmDetail",
        label: "代碼說明",
        thStyle: {
          "min-width": "210px",
        },
        tdStyle: {
          "font-size": "16px",
        },
      },
      {
        key: "startTime",
        label: "開始時間",
        thStyle: {
          "min-width": "200px",
        },
        tdStyle: {
          "font-size": "16px",
        },
      },
      {
        key: "endTime",
        label: "結束時間",
        thStyle: {
          "min-width": "200px",
        },
        tdStyle: {
          "font-size": "16px",
        },
      },
      {
        key: "durationTime",
        label: "持續時間",
        thStyle: {
          "min-width": "115px",
        },
        tdStyle: {
          "font-size": "16px",
        },
      },
    ];
    const operateLogItems = ref([
      // {
      //   status: "生產",
      //   alarmCode: "",
      //   alarmDetail: "",
      //   startTime: "2023-03-23 08:00:01",
      //   endTime: "2023-03-23 09:15:12",
      //   durationTime: "01:15:11",
      // },
      // {
      //   status: "生產",
      //   alarmCode: "E_MC_3_0003\nE_MC_3_0006",
      //   alarmDetail: "末端油壓不足\n挾料台浮動",
      //   startTime: "2023-03-23 08:00:01",
      //   endTime: "2023-03-23 09:15:12",
      //   durationTime: "01:15:11",
      // },
    ]);

    //當日完成工單資訊
    const completeWorkFields = [
      {
        key: "workOrgCode",
        label: "工單單號",
        thStyle: {
          "min-width": "110px",
        },
        tdStyle: {
          "font-size": "16px",
        },
      },
      {
        key: "itemName",
        label: "產品品名",
        thStyle: {
          "min-width": "280px",
        },
        tdStyle: {
          "font-size": "16px",
        },
      },
      {
        key: "qty",
        label: "派工數量(PCS)",
        thStyle: {
          "min-width": "150px",
        },
        tdStyle: {
          "font-size": "16px",
        },
      },
      {
        key: "completeQty",
        label: "完工數量(PCS)",
        thStyle: {
          "min-width": "150px",
        },
        tdStyle: {
          "font-size": "16px",
        },
      },
      {
        key: "weight",
        label: "派工重量(KG)",
        thStyle: {
          "min-width": "150px",
        },
        tdStyle: {
          "font-size": "16px",
        },
      },
      {
        key: "completeWeight",
        label: "完工重量(KG)",
        thStyle: {
          "min-width": "150px",
        },
        tdStyle: {
          "font-size": "16px",
        },
      },
      {
        key: "startTime",
        label: "開始時間",
        thStyle: {
          "min-width": "200px",
        },
        tdStyle: {
          "font-size": "16px",
        },
      },
      {
        key: "endTime",
        label: "完成時間",
        thStyle: {
          "min-width": "200px",
        },
        tdStyle: {
          "font-size": "16px",
        },
      },
    ];
    const completeWorkItems = ref([]);
    const workID = ref();
    const completeWorkdetail = ref(false);
    const completeWorkRowClick = (itemData) => {
      console.log(itemData.workOrgCode);
      workID.value = itemData.workOrgCode;
      completeWorkdetail.value = true;
    };
    provide("wip_lot", workID);

    //警報履歷資訊
    const alarmHistoryFields = [
      {
        key: "alarmCode",
        label: "警報代碼",
        thStyle: {
          "min-width": "125px",
        },
        tdStyle: {
          "font-size": "16px",
        },
      },
      {
        key: "alarmDetail",
        label: "警報代碼說明",
        thStyle: {
          "min-width": "200px",
        },
        tdStyle: {
          "font-size": "16px",
        },
      },
      {
        key: "alarmVideo",
        label: "機台影像",
        thStyle: {
          "min-width": "110px",
        },
        tdStyle: {
          "font-size": "16px",
        },
      },
      {
        key: "startTime",
        label: "開始時間",
        thStyle: {
          "min-width": "200px",
        },
        tdStyle: {
          "font-size": "16px",
        },
      },
      {
        key: "endTime",
        label: "結束時間",
        thStyle: {
          "min-width": "200px",
        },
        tdStyle: {
          "font-size": "16px",
        },
      },
      {
        key: "durationTime",
        label: "持續時間",
        thStyle: {
          "min-width": "115px",
        },
        tdStyle: {
          "font-size": "16px",
        },
      },
    ];
    const alarmHistoryItems = ref([
      // {
      //   alarmCode: "E_MC_3_0004",
      //   alarmDetail: "過負載異常",
      //   alarmVideo: "無",
      //   startTime: "2023-03-23 08:45:29",
      //   endTime: "2023-03-23 08:52:46",
      //   durationTime: "00:07:17",
      // },
    ]);

    //機台燈號
    const machineLightData = ref({});

    const updateData = () => {
      if (machStatusData.value != null) {
        machine_status.value = machStatusData.value.machine_status;
        deviceRunTime.value = machStatusData.value.deviceRunTime;
        deviceQueueTime.value = machStatusData.value.deviceQueueTime;
        deviceActivation.value = machStatusData.value.deviceActivation;
        stackBarInformation.value = machStatusData.value.stack_bar_information;
        percent_bar.value = machStatusData.value.percent_bar;
        deviceModel.value = machStatusData.value.device_model;
        deviceDayCount.value = machStatusData.value.device_day_count;
        deviceCapacityMin.value = machStatusData.value.device_capacity_min;

        workCodeItems.value = machStatusData.value.work_code_information;
        produceItems.value = machStatusData.value.produce_information;
        wireItems.value = machStatusData.value.wire_information;
        wireExtraItems.value[1] = machStatusData.value.wire_total_weight;
        mouldItems.value = machStatusData.value.mould_information;
        bucketItems.value = machStatusData.value.bucket_information;
        produceTimeItems.value =
          machStatusData.value.total_produce_time_information;
        insp_value.value = machStatusData.value.inspection_information;
        workCodeRemainItems.value =
          machStatusData.value.remain_work_order_information;

        operateLogItems.value = machStatusData.value.operateLogItems;
        alarmHistoryItems.value = machStatusData.value.alarmHistoryItems;
        machineLightData.value = machStatusData.value.machine_light_value;
      }
    };

    const queryMachineCamera = () => {
      var params = {};
      params["webPage"] =
        sideNavPath.value.length != 0
          ? sideNavPath.value[sideNavPath.value.length - 1]
          : null;
      params["user"] = loginData.value.account;
      params["vuePage"] = "machstatus";
      params["oper"] = operName.value;
      params["device_name"] = deviceName.value;
      params["methods"] = "POST";
      params["whichFunction"] = "QueryMachineCamera";
      console.log(params);
      methods.axiosAction(params).then(() => {
        var result = axiosResult.value;
        console.log(result);
        if (result["Response"] == "ok") {
          machineCameraData.value = result["QueryTableData"];
          console.log(machineCameraData.value);
        } else {
          machineCameraData.value = [];
          console.log("erro machineCameraData" + result["QueryTableData"]);
        }
      });
    };

    const queryWorkorderHistory = () => {
      let endTime = new Date();
      let startTime = new Date(endTime.getTime() - 172800000);
      var params = {};
      params["webPage"] =
        sideNavPath.value.length != 0
          ? sideNavPath.value[sideNavPath.value.length - 1]
          : null;
      params["user"] = loginData.value.account;
      params["vuePage"] = "machstatus";
      params["methods"] = "POST";
      params["whichFunction"] = "WorkorderHistory";
      params["startTime"] = `${startTime.getFullYear()}-${
        startTime.getMonth() + 1
      }-${startTime.getDate()} ${startTime.getHours()}:${startTime.getMinutes()}:${startTime.getSeconds()}`;
      params["endTime"] = `${endTime.getFullYear()}-${
        endTime.getMonth() + 1
      }-${endTime.getDate()} ${endTime.getHours()}:${endTime.getMinutes()}:${endTime.getSeconds()}`;
      params["deviceID"] = deviceName.value;
      params["siteName"] = siteName.value;
      params["oper"] = oper.value;

      methods.axiosAction(params).then(() => {
        var result = axiosResult.value;
        console.log(result);
        if (result["Response"] == "ok") {
          let result_Data = result["QueryTableData"];

          let workOrderHistoryArray = [];

          for (let i = 0; i < result_Data.length; i++) {
            let workOrderHistoryObj = {};
            workOrderHistoryObj["workOrgCode"] =
              result_Data[i]["work_org_code"];
            workOrderHistoryObj["itemName"] = result_Data[i]["itemName"];
            workOrderHistoryObj["qty"] = result_Data[i]["qty"];
            workOrderHistoryObj["completeQty"] = result_Data[i]["completeQty"];
            workOrderHistoryObj["weight"] = result_Data[i]["weight"];
            workOrderHistoryObj["completeWeight"] =
              result_Data[i]["completeWeight"];
            workOrderHistoryObj["startTime"] = result_Data[i]["startTime"];
            workOrderHistoryObj["endTime"] = result_Data[i]["endTime"];
            workOrderHistoryArray.push(workOrderHistoryObj);
          }
          completeWorkItems.value = workOrderHistoryArray;
        } else if (result["Response"] == "no data") {
          completeWorkItems.value = [];
          methods.setTimeoutAlert("查無資料");
        } else {
          completeWorkItems.value = [];
          methods.setTimeoutAlert(result["Response"]);
        }
        methods.triggerLoadingBar();
      });
    };

    watch(
      machStatusData,
      () => {
        updateData();
      },
      { deep: true }
    );

    watch(detailTabIndex, (newValue) => {
      switch (newValue) {
        case 2:
          queryMachineCamera();
          break;
        case 4:
          methods.triggerLoadingBar();
          queryWorkorderHistory();
          break;

        default:
          break;
      }
    });

    return {
      siteName,
      operName,
      deviceName,
      detail,
      machineImage,
      nowTime,
      deviceRunTime,
      deviceQueueTime,
      deviceActivation,
      deviceModel,
      deviceDayCount,
      deviceCapacityMin,
      machine_status,
      stacksBarClass,
      stacksBarMaxValue,
      stackBarInformation,
      detailTabIndex,
      workCodeFields,
      workCodeItems,
      produceFields,
      produceItems,
      percent_bar,
      wireFields,
      wireItems,
      wireExtraItems,
      mouldFields,
      mouldItems,
      bucketFields,
      bucketItems,
      produceTimeFields,
      produceTimeItems,
      insp_value,

      workCodeRemainFields,
      workCodeRemainItems,
      machineCameraData,
      operateLogFields,
      operateLogItems,
      completeWorkFields,
      completeWorkItems,
      completeWorkdetail,
      completeWorkRowClick,
      alarmHistoryFields,
      alarmHistoryItems,
      machineLightData,
    };
  },
};
</script>

<style></style>
